import { render, staticRenderFns } from "./personalProject.vue?vue&type=template&id=6a4e92b6&scoped=true&"
import script from "./personalProject.vue?vue&type=script&lang=js&"
export * from "./personalProject.vue?vue&type=script&lang=js&"
import style0 from "./personalProject.vue?vue&type=style&index=0&id=6a4e92b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e92b6",
  null
  
)

export default component.exports